var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSociiConfirmation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 149.533,
    height: 149.103,
    viewBox: "0 0 149.533 149.103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #FF6600;\n      }\n\n      .cls-2 {\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_979",
    "data-name": "Group 979",
    transform: "translate(4021.805 -2037.517)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_977",
    "data-name": "Group 977"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_982",
    "data-name": "Group 982",
    transform: "translate(177.995 71)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_980",
    "data-name": "Group 980"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2452",
    "data-name": "Path 2452",
    className: "cls-1",
    d: "M-4059.49,2045.46a70.235,70.235,0,0,1-70.16,70.16,70.233,70.233,0,0,1-70.15-70.16,70.23,70.23,0,0,1,70.15-70.15A70.233,70.233,0,0,1-4059.49,2045.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2453",
    "data-name": "Path 2453",
    className: "cls-1",
    d: "M-4154.455,2059.622v22.751l-19.71-34.127Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2454",
    "data-name": "Path 2454",
    className: "cls-1",
    d: "M-4142.946,2066.271l-9.3,16.109v-21.486Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2455",
    "data-name": "Path 2455",
    className: "cls-1",
    d: "M-4109.12,2083.255l-18.339-10.593,9.173-5.293Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2456",
    "data-name": "Path 2456",
    className: "cls-1",
    d: "M-4131.871,2072.662l-18.339,10.593,9.173-15.885Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    "data-name": "Path 2457",
    className: "cls-1",
    d: "M-4109.833,2085.387H-4149.5l19.835-11.446Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2458",
    "data-name": "Path 2458",
    className: "cls-1",
    d: "M-4119.391,2065.46l-10.271,5.929-10.277-5.929,10.277-17.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2459",
    "data-name": "Path 2459",
    className: "cls-1",
    d: "M-4131.57,2046.561l-10.271,17.794-10.4-6v-11.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    className: "cls-1",
    d: "M-4154.448,2046.561v10.516l-18.221-10.516Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    className: "cls-1",
    d: "M-4154.448,2033.542v10.817h-18.731Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    className: "cls-1",
    d: "M-4154.448,2008.547V2031l-19.451,11.236Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2463",
    "data-name": "Path 2463",
    className: "cls-1",
    d: "M-4131.578,2044.359h-20.668V2032.27l10.271-5.929Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2464",
    "data-name": "Path 2464",
    className: "cls-1",
    d: "M-4143.079,2024.425l-9.167,5.3v-21.178Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2465",
    "data-name": "Path 2465",
    className: "cls-1",
    d: "M-4119.258,2025.236l-10.4,18.025-10.4-18.025,10.4-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2466",
    "data-name": "Path 2466",
    className: "cls-1",
    d: "M-4131.871,2017.958l-9.3,5.37-9.306-16.116Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2467",
    "data-name": "Path 2467",
    className: "cls-1",
    d: "M-4110.364,2005.533l-19.3,11.152-19.312-11.152Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2468",
    "data-name": "Path 2468",
    className: "cls-1",
    d: "M-4108.854,2007.211l-9.306,16.116-9.3-5.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2469",
    "data-name": "Path 2469",
    className: "cls-1",
    d: "M-4085.424,2042.226-4104.875,2031v-22.465Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2470",
    "data-name": "Path 2470",
    className: "cls-1",
    d: "M-4107.078,2008.554v21.164l-9.166-5.293Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2471",
    "data-name": "Path 2471",
    className: "cls-1",
    d: "M-4107.078,2032.27v12.089h-20.675l10.4-18.018Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2472",
    "data-name": "Path 2472",
    className: "cls-1",
    d: "M-4086.145,2044.359h-18.731v-10.817Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2473",
    "data-name": "Path 2473",
    className: "cls-1",
    d: "M-4086.648,2046.561l-18.228,10.516v-10.516Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2474",
    "data-name": "Path 2474",
    className: "cls-1",
    d: "M-4107.078,2046.561v11.8l-10.4,6-10.278-17.794Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2475",
    "data-name": "Path 2475",
    className: "cls-1",
    d: "M-4107.078,2060.895v21.472l-9.3-16.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2476",
    "data-name": "Path 2476",
    className: "cls-1",
    d: "M-4085.173,2048.253l-19.7,34.134v-22.758Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2477",
    "data-name": "Path 2477",
    className: "cls-1",
    d: "M-4075.784,2040.131l-.014-.028-.21-.371-.147-.244-23.324-40.4-.217-.378-.147-.251-.07-.119h-48.642l-.07.119-.147.251-.21.364h-.049l.042.021-23.324,40.392-.147.251-.21.364h-.049l.042.021-.175.392.049.076.14.245.21.364,23.332,40.42.139.244.217.371-.028.042.035-.021.2.342h48.642l.2-.342.035.021-.021-.042.209-.371.147-.244,23.318-40.4.042.028-.028-.056.21-.357.14-.252.07-.118Zm-23.661-14.124v-22.464l19.452,33.693Zm0,13.362v-10.817l18.732,10.817Zm0,12.718v-10.516h18.228Zm0,25.31v-22.758l19.7-11.376Zm-47.369-.007v-21.485l9.3,5.376Zm11.075-59.053-9.306-16.116,18.6,10.747Zm-11.075,21.032V2027.28l10.271-5.929,10.4,18.018Zm22.576-27.674-19.311-11.152h38.616Zm22.591,15.585v12.089h-20.675l10.4-18.018Zm-20.381-14.312,18.6-10.747-9.306,16.116Zm-4.412,54.7-18.339,10.592,9.173-15.885Zm4.412,0,9.173-5.293,9.167,15.885Zm-2.2-1.273-10.278-5.929,10.278-17.8,10.272,17.8Zm19.829,14h-39.664l19.835-11.446Zm2.755-38.826v11.795l-10.4,6-10.278-17.794Zm-22.584-3.3-10.4-18.025,10.4-6,10.4,6Zm-22.583,15.095v-11.795h20.675l-10.271,17.794Zm45.167,2.539v21.471l-9.3-16.095Zm-9.166-36.47,9.166-15.871v21.164Zm-36,5.3v-21.178l9.166,15.878Zm-21.654,12.508,19.451-33.686v22.45Zm19.451,4.328v10.516l-18.22-10.516Zm-18.731-2.2,18.731-10.817v10.817Zm-.986,3.887,19.71,11.376v22.751Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_981",
    "data-name": "Group 981"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2478",
    "data-name": "Path 2478",
    className: "cls-2",
    d: "M-4124.22,1967.517a73.029,73.029,0,0,0-72.953,72.953,73.034,73.034,0,0,0,72.953,72.953,73.039,73.039,0,0,0,72.953-72.953A73.034,73.034,0,0,0-4124.22,1967.517Zm0,143.109a70.233,70.233,0,0,1-70.156-70.156,70.233,70.233,0,0,1,70.156-70.156,70.233,70.233,0,0,1,70.156,70.156A70.233,70.233,0,0,1-4124.22,2110.626Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_976",
    "data-name": "Group 976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_2411",
    "data-name": "Path 2411"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2479",
    "data-name": "Path 2479",
    d: "M-4100.333,1999.075h-47.8l-23.9,41.392.035.049,23.863,41.349h47.8l.154-.258,23.745-41.14Zm-47.956,81.049-22.451-38.874,22.451,12.955Zm0-26.758-21.7-12.529h21.7Zm0-13.263h-22.2l22.2-12.823Zm0-13.676-22.193,12.823,22.193-38.434Zm24.268,13.676h-.419l.209-.364-11.41-19.759,11.41-6.586,11.4,6.586-11.4,19.759Zm-.21,27.142-11.277-6.509,11.277-19.535,11.271,19.535Zm11.642-5.866,10.907,18.892-21.814-12.6Zm-12.383,6.293-21.814,12.6,10.907-18.892Zm1.468-54.7,22.088-12.753-11.04,19.122Zm21.312-13.152-22.046,12.732-22.052-12.732Zm-22.78,13.152-11.04,6.376-11.04-19.122Zm-22.583-12.152,10.914,18.892-10.914,6.306Zm0,26.044,11.278-6.509,11.4,19.752h-22.681Zm0,13.977h22.688l.217-.356.2.356h-.42l-11.277,19.535-11.411-6.579Zm0,13.8,11.047,6.376-11.047,19.123Zm.741,26.506,22.576-13.04,22.577,13.04Zm45.9-1.014-11.04-19.116,11.04-6.376Zm-11.4-19.752-11.277-19.535h-.427l.21-.363.217.363h22.674l.007,12.956Zm11.4-20.269h-22.681l11.411-19.752,11.27,6.509Zm0-14.1-10.907-6.3,10.907-18.878Zm.734-25.2,22.192,38.434-22.192-12.809Zm0,26.471,22.206,12.823h-22.206Zm0,13.557h21.7l-21.7,12.529Zm0,13.376,22.444-12.956-22.444,38.888Zm-.7,28.542v-28.946l25.052-14.462Zm1.4-28.139v22.919l19.835-34.369Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_2412",
    "data-name": "Path 2412"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2480",
    "data-name": "Path 2480",
    d: "M-4075.788,2040.134l-.014-.028-.209-.377-.147-.238-23.318-40.4-.224-.377-.14-.252-.076-.119h-48.636l-.07.119-.146.252-.217.363h-.049l.042.021-23.318,40.392-.147.245-.216.37h-.042l.042.021-.175.392.042.077.147.245.2.363,23.339,40.42.133.238.217.377-.028.042.042-.021.2.343h48.636l.2-.343.035.021-.021-.042.21-.377.147-.238,23.318-40.4.042.028-.028-.056.209-.356.14-.252.07-.119Zm-58.85-19.884,10.4-6,10.411,6-10.411,18.025Zm20.682,40.224-10.278,5.929-10.278-5.929,10.278-17.8Zm-8.069-47.5,18.6-10.746-9.306,16.116Zm17.088-12.424-19.3,11.152-19.311-11.152Zm-21.506,12.424-9.3,5.37-9.3-16.116Zm-20.375-9.418,9.167,15.886-9.167,5.3Zm0,23.73,10.271-5.929,10.4,18.018h-20.668Zm0,14.292h20.682l-10.278,17.794-10.4-6.006Zm-20,3.593,17.095,9.866v19.738Zm-.93-5.8,18.731-10.823v10.823Zm18.731,2.2v10.515l-18.221-10.515Zm0-38.022v22.458l-19.444,11.236Zm2.2,52.355,9.3,5.377-9.3,16.109Zm11.215,6.474,9.16,5.293-18.333,10.593Zm-8.46,18.018,19.829-11.445,19.829,11.445Zm22.038-12.725,9.174-5.293,9.166,15.886Zm20.375,9.7-9.3-16.095,9.3-5.377Zm0-24.017-10.4,6.006-10.271-17.794h20.668Zm0-13.991h-20.668l10.4-18.018,10.264,5.929Zm0-14.641-9.16-5.292,9.16-15.879Zm2.2-21.192,19.451,33.7-19.451-11.229Zm0,25.01,18.731,10.823h-18.731Zm0,13.026h18.228l-18.228,10.515Zm0,35.826v-22.759l19.71-11.375Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSociiConfirmation);
export default __webpack_public_path__ + "static/media/sociiConfirmation.111c459a66dc32b739f7524e63a71662.svg";
export { ForwardRef as ReactComponent };